import {Inject, Component} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-signup-modal',
  templateUrl: './signup-modal.component.html',
  styleUrls: ['./signup-modal.component.css'],
  imports: [
    NgIf
  ],
  standalone: true
})
export class SignUpModalComponent {
  loggedIn: boolean = false;
  type: string = "Login";
  eventID: string = "Geen";

  constructor(
    private dialogRef: MatDialogRef<SignUpModalComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.loggedIn = data.loggedIn;
    this.type = data.type;
    this.eventID = data.eventID;
  }

  /**
   * Closes the modal with a truthy value.
   */
  signUp() {
    this.dialogRef.close(true);
  }

  /**
   * Closes the modal with a falsy value.
   */
  close() {
    this.dialogRef.close(false);
  }

  /**
   * Closes the modal with a falsy value and redirects the user to the login page.
   */
  redirectToLogin() {
    this.dialogRef.close(false);
    this.router.navigate(['/account/inloggen'], { queryParams: { redirect: 'activiteit', id: this.eventID } });
  }

  /**
   * Closes the modal with a falsy value and deletes the current activity.
   */
  deleteActivity():void {
    this.dialogRef.close(true);
  }
}
